import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import "./Price.css";
import { useNavigate } from "react-router-dom";
import basic1 from "../../new_Images/1/reshot-icon-contact-form-R3ZMVXK89S.svg";
import basic2 from "../../new_Images/1/reshot-icon-domain-registration-DT6SY2KNMW.svg";
import basic3 from "../../new_Images/1/reshot-icon-web-hosting-and-ftp-YAL35QC47U.svg";
import basic4 from "../../new_Images/1/reshot-icon-page-content-SAXPLZBG8Y.svg";
import basic5 from "../../new_Images/1/reshot-icon-landing-page-N3G6AHTVKY.svg";
import basic6 from "../../new_Images/1/reshot-icon-broken-link-JQEZPX9SBR.svg";
import basic7 from "../../new_Images/1/reshot-icon-map-billboard-YVG9PF572S.svg";
import basic8 from "../../new_Images/1/reshot-icon-map-gps-ZJH4KFSWTL.svg";
import basic9 from "../../new_Images/1/reshot-icon-mobile-design-SX2VRJ7CQ9.svg";
import basic10 from "../../new_Images/1/reshot-icon-mobile-design-SX2VRJ7CQ9.svg";
import basic11 from "../../new_Images/1/reshot-icon-whatsapp-UANBKF398R.svg";

import Standard1 from "../../new_Images/2/reshot-icon-important-email-TRXVZ8GKDP.svg";
import Standard2 from "../../new_Images/2/reshot-icon-24-7-monitoring-D4TQ2UZBKY.svg";
import Standard3 from "../../new_Images/2/reshot-icon-gallery-selection-W9C5V6UD4J.svg";
import Standard4 from "../../new_Images/2/reshot-icon-search-inspiration-TW68AJDGFK.svg";
import Standard5 from "../../new_Images/2/reshot-icon-testimonials-4EYQMFCGH8.svg";
import Standard6 from "../../new_Images/2/reshot-icon-shield-tick-DVH6JGXTFK.svg";
import Standard7 from "../../new_Images/2/reshot-icon-time-4LWFCUAJ78.svg";

import Bonanza1 from "../../new_Images/3/reshot-icon-24-7-monitoring-D4TQ2UZBKY.svg";
import Bonanza2 from "../../new_Images/3/reshot-icon-computer-shield-927DG34E8C.svg";
import Bonanza3 from "../../new_Images/3/reshot-icon-contact-form-F8PDAU4JKS.svg";
import Bonanza4 from "../../new_Images/3/reshot-icon-typing-an-email-YWBVZ6XK2L.svg";
import Bonanza5 from "../../new_Images/3/reshot-icon-lock-YT45QP3Z7F.svg";
import Bonanza6 from "../../new_Images/3/reshot-icon-speed-E58N3CQLY7.svg";
import Bonanza7 from "../../new_Images/3/reshot-icon-chat-X95JPD8FL2.svg";
// import Bonanza8 from '../../new_Images/3/reshot-icon-tick-K7PLGWCM56.svg'
import Bonanza9 from "../../new_Images/3/reshot-icon-contact-form-AUPGZY7ESB.svg";

import star from "../../new_Images/3/reshot-icon-star-UT2SJ39LPZ.svg";
import dimond from "../../new_Images/3/reshot-icon-diamond-2XBFT3L9GQ.svg";
import rocket from "../../new_Images/3/reshot-icon-rocket-VFZQ8AH67M.svg";

export default function WebsitePricingPlans() {
  const Icons = {
    star: (
      <svg
        className="plan-icon-inline"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        width="30"
        height="30"
        fill="gold"
        style={{ marginRight: "8px" }}>
        <path d="M316.7 17.8L367.5 150.2 510.7 171.5C526.7 173.8 533.9 193.6 522.4 204.6L412 311.5 438.8 454.4C441.5 470.3 424.8 481.9 411.1 474.8L288 409.6 164.9 474.8C151.2 481.9 134.5 470.3 137.2 454.4L164 311.5 53.6 204.6C42.1 193.6 49.3 173.8 65.3 171.5L208.5 150.2 259.3 17.8C265.1 3.7 310.9 3.7 316.7 17.8z" />
      </svg>
    ),
    gem: (
      <svg
        className="plan-icon-inline"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        width="30"
        height="30"
        fill="purple"
        style={{ marginRight: "8px" }}>
        <path d="M485.5 0H90.5L0 160l288 352L576 160 485.5 0zM433.3 32l55.5 96h-96l-32-96h72.5zM288 64l39 96h-78l39-96zM118.7 32H191l-32 96h-96l55.7-96zM48 192l65.5-64h97.1l63.5 160L48 192zm240 240L192 224h192l-96 208zm48-240l63.5-160h97.1L528 192 336 192z" />
      </svg>
    ),
    rocket: (
      <svg
        className="plan-icon-inline"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="30"
        height="30"
        fill="crimson"
        style={{ marginRight: "8px" }}>
        <path d="M505 19.1c-2.4-9.8-12.3-15.5-22-13.1-44.5 10.7-121.8 38.2-170.9 87.3-16.2 16.2-29.7 33.2-40.6 50.6L144 240H96l-64 64v48h48l64-64v-48l96.1-127.5c17.4-10.9 34.4-24.3 50.6-40.6C456.8 141 484.3 63.7 495 19.1zM96 320l-32 32h-16v-16l32-32h16v16zM192 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-10.7 2.7-20.8 7.5-29.6l86.1-86.1c4.5-4.5 11.8-4.5 16.3 0l41.2 41.2c4.5 4.5 4.5 11.8 0 16.3l-86.1 86.1c8.9 4.8 18.9 7.5 29.6 7.5 35.3 0 64-28.7 64-64z" />
      </svg>
    ),
  };

  const navigate = useNavigate();

  const handleChoosePlan = () => {
    navigate("/ContactUsForm");
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div
        className="pricing-heading Text-Gradient px-5 py-2"
        style={{ fontFamily: "rockwell" }}>
        <h1 className="">
          <b> Our Website Plans</b>
        </h1>
      </div>
      <div
        className="pricing-card-container Features-card-section"
        style={{ backgroundColor: "#FFFEFA" }}>
        {/* Basic Plan */}
        <Card className="Features-card-New">
          <div className="card-headings">
            {/* <h2 className="plan-title">{Icons.star} Basic Plan</h2> */}
            <h2 className="plan-title flex items-center gap-2 Text-Gradient">
              <img src={star} alt="Star Icon" className="w-1 h-1" />
              Basic Plan
            </h2>

            <p className="plan-subtext">Starter Website</p>
          </div>
          <div className="plan-text space-y-2">
            <p className="flex items-center gap-[5px]">
              <img src={basic2} alt="Domain Icon" className="icon w-2 h-5" />
              Free Domain Name
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic3} alt="Hosting Icon" className="icon w-2 h-5" />
              Free Hosting for 1 Year
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic5} alt="Pages Icon" className="icon w-2 h-5" />5
              Pages (Static Website)
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={basic10}
                alt="Responsive Icon"
                className="icon w-2 h-5"
              />
              100% Responsive Website
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={basic6}
                alt="Social Media Icon"
                className="icon w-2 h-5"
              />
              Social Media Integration
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic7} alt="Map Icon" className="icon w-2 h-5" />
              Google Map Integration
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={basic1}
                alt="Contact Form Icon"
                className="icon w-2 h-5"
              />
              Inquiry Form
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic11} alt="WhatsApp Icon" className="icon w-2 h-5" />
              WhatsApp Chat Integration
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic8} alt="Map GPS Icon" className="icon w-2 h-5" />
              Google Map Integration
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={basic9} alt="Mobile Icon" className="icon w-2 h-5" />
              Mobile Responsive
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={basic4}
                alt="Sliding Images Icon"
                className="icon w-2 h-5"
              />
              Sliding Images (Animation)
            </p>
          </div>

          <div className="mt-2 card-footer">
            <h3 className="plan-price Text-Gradient">₹ 5k - 20k</h3>
            {/* <Button className="button-56" label="Choose Plan" /> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                className="btn-styles btn"
                label="Choose Plan"
                onClick={handleChoosePlan}
              />
            </div>
          </div>
        </Card>

        {/* Standard Plan */}
        <Card className="Features-card-New">
          <div className="card-headings">
            {/* <h2 className="plan-title">{Icons.gem} Standard Plan</h2> */}
            <h2 className="plan-title Text-Gradient flex items-center gap-2">
              <img src={dimond} alt="Star Icon" className="w-1 h-1" />
              Standard Plan
            </h2>
            <p className="plan-subtext">Business Website</p>
            <div className="plan-text space-y-2">
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard6}
                  alt="Domain Icon"
                  className="icon w-2 h-5"
                />
                All Basic plans Included
              </p>
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard4}
                  alt="Hosting Icon"
                  className="icon w-2 h-5"
                />
                Basic SEO
              </p>
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard1}
                  alt="Pages Icon"
                  className="icon w-2 h-5"
                />
                3 Business Emails (Domain Mails)
              </p>
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard2}
                  alt="Responsive Icon"
                  className="icon w-2 h-5"
                />
                Email Support
              </p>
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard3}
                  alt="Social Media Icon"
                  className="icon w-2 h-5"
                />
                Portfolio or Gallery
              </p>
              {/* <p className="flex items-center gap-[5px]">
                <img src={Standard5} alt="Map Icon" className="icon w-2 h-5" />
                Testimonials or Blog Section
              </p> */}
              <p className="flex items-center gap-[5px]">
                <img
                  src={Standard7}
                  alt="Contact Form Icon"
                  className="icon w-2 h-5"
                />
                Business Hours Support
              </p>
            </div>
          </div>

          <div className="mt-2 card-footer">
            <h3
              className="plan-price Text-Gradient"
              style={{ marginTop: "auto" }}>
              ₹ 20k - 60k
            </h3>
            {/* <Button className="button-56" label="Choose Plan" /> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                className="btn-styles btn"
                label="Choose Plan"
                onClick={handleChoosePlan}
              />
            </div>
          </div>
        </Card>

        {/* Bonanza Plan */}
        <Card className="Features-card-New">
          <div className="card-headings">
            {/* <h2 className="plan-title">{Icons.rocket} Bonanza Plan</h2> */}
            <h2 className="plan-title Text-Gradient flex items-center gap-2">
              <img src={rocket} alt="Star Icon" className="w-1 h-1" />
              Bonanza Plan
            </h2>
            <p className="plan-subtext">Business Website</p>
          </div>
          <div className="plan-text space-y-2">
            <p className="flex items-center gap-[5px]">
              <img src={Standard6} alt="Domain Icon" className="icon w-2 h-5" />
              All Standard Plans Included
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={Bonanza6} alt="Hosting Icon" className="icon w-2 h-5" />
              High-Speed Free Hosting
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={Bonanza5} alt="Pages Icon" className="icon w-2 h-5" />3
              Free SSL Certification
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={Bonanza1}
                alt="Responsive Icon"
                className="icon w-2 h-5"
              />
              24/7 System Monitoring
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={Bonanza4}
                alt="Social Media Icon"
                className="icon w-2 h-5"
              />
              10 Business Emails (Domain Mails)
            </p>
            <p className="flex items-center gap-[5px]">
              <img src={Bonanza2} alt="Map Icon" className="icon w-2 h-5" />
              Control Panel Access
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={Bonanza3}
                alt="Contact Form Icon"
                className="icon w-2 h-5"
              />
              SEO Ready Website
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={Bonanza7}
                alt="Contact Form Icon"
                className="icon w-2 h-5"
              />
              Live chat Integration
            </p>
            <p className="flex items-center gap-[5px]">
              <img
                src={Bonanza9}
                alt="Contact Form Icon"
                className="icon w-2 h-5"
              />
              Customs Forms
            </p>
          </div>
          <div className="mt-2 card-footer" style={{ marginTop: "auto" }}>
            <h3 className="plan-price Text-Gradient">₹ 60k - 1L+</h3>
            {/* <Button className="button-56" label="Choose Plan" /> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                className="btn-styles btn"
                label="Choose Plan"
                onClick={handleChoosePlan}
              />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
